import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";
import { CreateCustomDomain, CustomDomain } from "./models";

const sso = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: CROSS_API_URL + "/domains" }),
    reducerPath: 'api.sso',
    tagTypes: ['sso'],
    endpoints: (builder) => ({
        getCustomDomains: builder.query<CustomDomain[], null>({
            query: () => ({
                url: "/auth0/available",
                method: "GET",
            }),
        }),
        createCustomDomain: builder.mutation<{insert: number}, CreateCustomDomain>({
            query: (domain) => ({
                url: "/",
                method: "POST",
                body: domain,
            }),
        }),
        deleteCustomDomain: builder.mutation<{delete: number}, string>({
            query: (id) => ({
                url: `/${id}`,
                method: "DELETE",
            }),
        }),
        bulkDeleteCustomDomains: builder.mutation<{delete: number}, string[]>({
            query: (ids) => ({
                url: "/bulk",
                method: "DELETE",
                body: { ids },
            }),
        }),
        bulkCreateCustomDomains: builder.mutation<{insert: number}, CreateCustomDomain[]>({
            query: (domains) => ({
                url: "/bulk",
                method: "POST",
                body: { domains },
            }),
        }),
    }),
});

export const { useGetCustomDomainsQuery, useCreateCustomDomainMutation, useDeleteCustomDomainMutation, useBulkDeleteCustomDomainsMutation, useBulkCreateCustomDomainsMutation } = sso;
export default sso;